<template>
  <div class="go-next">
    <div @click="goNext">{{ btnTxt }}</div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
export default {
  name: "GoNext",
  props:{
    'href':{
      type:String,
      default:'/'
    },
    'selected':{
      type:String,
      default:'-',
    },
    'required':{
      type:String,
      default:"false"
    }
  },
  data(){
    return {
      btnTxt:"Submit",
    }
  },
  computed:{
    //获取通过vuex管理的数据
    ...mapState(['true_answer','question_list'])
  },
  created() {

    if(this.$slots.default !== undefined){
      this.btnTxt = this.$slots.default[0].text;
    }
  },
  methods:{
    goNext:function(){
      //判断是否选择答案
      if(this.required==="true" && this.selected===""){
        this.$msgbox({
          title: 'Warning',
          message: 'One answer must be chosen.',
          showCancelButton: false,
          confirmButtonText: 'Confirm',
        }).then(()=>{});
        return ;
      }
      //判断是否是验证答案
      if(this.btnTxt === 'Submit'){
        let index = this.question_list.findIndex(item => item.option == this.selected)
        this.question_list.forEach(function(item){
          item.checked = 'animate-enter';
        });
        if(this.true_answer == index){
          this.question_list[index].checked = "animate-enter true";
        }else{
          this.question_list[index].checked = "animate-enter false";
          this.question_list[this.true_answer].checked = "animate-enter true";
        }
        //if(this.question_list.length == 2 && this.question_list[0].answer == 'YES' && this.selected == 'A') {
        //  this.$emit('secondQuestion', 'show2');
        //}else {
          this.btnTxt = 'Next'
          this.$store.commit('set_question_list',this.question_list);
          this.$store.commit('set_is_click',false);
        //}
        return;
      }
      let percent = this.$route.meta.percent;
      let lesson = this.$route.meta.lesson;
      let section = this.$route.meta.section;
      let lessonInfo = this.tool.getLocalData('lessonInfo');
      if(lessonInfo == null){
        lessonInfo = new Array();
        let lessonItem = {
          lesson:lesson,
          sections:[
            {
              section:section,
              selected:this.selected,
              percent:percent
            }
          ],
        };
        lessonInfo.push(lessonItem);
      }else{
        let _this = this;
        let existLesson = false;
        lessonInfo.forEach(function(value,index){
          if(value.lesson === lesson){ //相同的课程
            existLesson = true;
            let existSection = false;
            for(let i =0 ;i<value.sections.length;i++){
              if(value.sections[i].section === section){ //已经学习过该section
                existSection = true;
              }
            }
            if(existSection===false){
              value.sections.push({
                section:section,
                selected:_this.selected,
                percent:percent
              });
            }
          }
        });
        //没有学习过的课程
        if(existLesson === false){
          let lessonItem = {
            lesson:lesson,
            sections:[
              {
                section:section,
                selected:this.selected,
                percent:percent
              }
            ],
          }
          lessonInfo.push(lessonItem);
        }

      }
      this.tool.setLocalData('lessonInfo',lessonInfo);

      this.$router.push({
        path:this.href
      });
    }
  }
}
</script>

<style scoped>

</style>
